<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">消费统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-list">
            <a-table rowKey="id" :columns="columns" :data-source="data">
                <a slot="name" slot-scope="text">{{ text }}</a>
            </a-table>
        </div>
    </div>
</template>


<script>
const columns = [
  {
    title: 'TD',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '金额',
    dataIndex: 'money',
    key: 'money',
  },
  {
    title: '方式',
    dataIndex: 'remark',
    key: 'remark',
    ellipsis: true,
  },
  {
    title: '时间',
    dataIndex: 'add_time',
    key: 'add_time',
    ellipsis: true,
  }
];

export default {
    data(){
        return{
            columns,
            data:[]
        }
    },
    mounted(){
        // 地址
        this.$axios.get('/api/moneylog',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.data=res.data.data.lists
            }else{
                this.$message.error(res.data.msg);
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/consume.vue